/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { useParams } from "next/navigation";
const copy = {
    de: {
        title: "Etwas ist schiefgelaufen.",
        message: "Bitte versuchen Sie es erneut. Falls das Problem weiterhin besteht, pr\xfcfen Sie bitte auch, ob Ihr Browser unterst\xfctzt wird.",
        browserHint: "BillStore unterst\xfctzt die neuesten Versionen von Chrome, Edge, Firefox und Safari. Die Mindestversionen sind Chrome 111, Edge 111, Firefox 111, Safari 16.4 und iOS Safari 16.4. F\xfcr die beste Stabilit\xe4t der Rechnungs-PDF-Vorschau auf Apple-Ger\xe4ten wird Safari/iOS Safari 17.4 oder neuer empfohlen.",
        retry: "Erneut versuchen"
    },
    en: {
        title: "Something went wrong.",
        message: "Please try again. If the problem persists, also check whether your browser is supported.",
        browserHint: "BillStore supports the latest versions of Chrome, Edge, Firefox, and Safari. Minimum supported versions are Chrome 111, Edge 111, Firefox 111, Safari 16.4, and iOS Safari 16.4. For best invoice PDF preview stability on Apple devices, Safari/iOS Safari 17.4 or newer is recommended.",
        retry: "Try again"
    }
};
export default function Error(param) {
    let { error, reset } = param;
    const params = useParams();
    const lng = (params === null || params === void 0 ? void 0 : params.lng) === "de" ? "de" : "en";
    const texts = copy[lng];
    useEffect(()=>{
        Sentry.captureException(error);
    }, [
        error
    ]);
    return /*#__PURE__*/ _jsx("div", {
        style: {
            minHeight: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            backgroundColor: "#F8F9FF"
        },
        children: /*#__PURE__*/ _jsxs("div", {
            role: "alert",
            style: {
                maxWidth: "640px",
                width: "100%",
                borderRadius: "20px",
                backgroundColor: "#FFF",
                boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08)",
                padding: "28px",
                color: "#1F2937"
            },
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    style: {
                        margin: "0 0 12px",
                        fontSize: "24px"
                    },
                    children: texts.title
                }),
                /*#__PURE__*/ _jsx("p", {
                    style: {
                        margin: "0 0 16px",
                        lineHeight: 1.6
                    },
                    children: texts.message
                }),
                /*#__PURE__*/ _jsx("p", {
                    style: {
                        margin: "0 0 24px",
                        lineHeight: 1.6,
                        color: "#4B5563",
                        backgroundColor: "#F3F5FD",
                        borderRadius: "12px",
                        padding: "14px 16px"
                    },
                    children: texts.browserHint
                }),
                /*#__PURE__*/ _jsx("button", {
                    onClick: // Attempt to recover by trying to re-render the segment
                    ()=>reset(),
                    style: {
                        border: "none",
                        borderRadius: "999px",
                        backgroundColor: "#3B82F6",
                        color: "#FFF",
                        cursor: "pointer",
                        fontWeight: 600,
                        padding: "12px 20px"
                    },
                    children: texts.retry
                })
            ]
        })
    });
}
